import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  GetIndustrialSectorsResponse,
  ProblemDetails
} from '../../models';

import { useCustomWelcomeClient } from '../../custom-client.tsx';
import type { ErrorType } from '../../custom-client.tsx';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns a list of Industrial sectors and their translations, based on the Accept-Language header.<br><br><b>Required Scopes</b><br>welcome.doka.com/onboarding<br>welcome.doka.com/onboarding-backoffice
 */
export const useGetIndustrialSectorsHook = () => {
        const getIndustrialSectors = useCustomWelcomeClient<GetIndustrialSectorsResponse>();

        return useCallback((

 signal?: AbortSignal
) => {


        return getIndustrialSectors(
          {url: `/industrial-sectors`, method: 'GET', signal
    },
          );
        }, [getIndustrialSectors])
      }




export const getGetIndustrialSectorsQueryKey = () => {
    return [
    `/industrial-sectors`
    ] as const;
    }


export const useGetIndustrialSectorsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetIndustrialSectorsHook>>>, TError = ErrorType<ProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIndustrialSectorsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIndustrialSectorsQueryKey();

  const getIndustrialSectors =  useGetIndustrialSectorsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetIndustrialSectorsHook>>>> = ({ signal }) => getIndustrialSectors(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIndustrialSectorsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIndustrialSectorsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetIndustrialSectorsHook>>>>
export type GetIndustrialSectorsQueryError = ErrorType<ProblemDetails>


export function useGetIndustrialSectors<TData = Awaited<ReturnType<ReturnType<typeof useGetIndustrialSectorsHook>>>, TError = ErrorType<ProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIndustrialSectorsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetIndustrialSectorsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetIndustrialSectorsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIndustrialSectors<TData = Awaited<ReturnType<ReturnType<typeof useGetIndustrialSectorsHook>>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIndustrialSectorsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetIndustrialSectorsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetIndustrialSectorsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIndustrialSectors<TData = Awaited<ReturnType<ReturnType<typeof useGetIndustrialSectorsHook>>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIndustrialSectorsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetIndustrialSectors<TData = Awaited<ReturnType<ReturnType<typeof useGetIndustrialSectorsHook>>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIndustrialSectorsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetIndustrialSectorsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






